import { GridColDef } from '@mui/x-data-grid-pro';

import { DataGrid, DataGridLayout, ApiWorkflowDialog } from '@verantos-dev/shared-components';

import { useAccuracyMatrix } from '../hooks/useAccuracyMatrix';
import type { AccuracyConcept } from '../types/types';

type AccuracyMatrixProps = {
  selectedConcept: AccuracyConcept | null;
  setSelectedConcept: (concept: AccuracyConcept | null) => void;
  setOpenConfusionMatrixDialog: (value: boolean) => void;
};

const AccuracyMatrix = ({
  selectedConcept,
  setSelectedConcept,
  setOpenConfusionMatrixDialog,
}: AccuracyMatrixProps) => {
  const { useFetchDataGridData, confusionMatrixColumns } = useAccuracyMatrix();
  return (
    <ApiWorkflowDialog
      id="accuracy-confusion-matrix-dialog"
      title={selectedConcept?.conceptName || ''}
      size="large"
      displayButtons={false}
      onClose={() => {
        setSelectedConcept(null);
        setOpenConfusionMatrixDialog(false);
      }}
    >
      <DataGridLayout id="data-reliability-confusion-layout" sx={{ minHeight: 0 }}>
        <DataGrid
          id="confusion-matrix"
          mode="client"
          pagination={false}
          rows={[selectedConcept]}
          getRowId={(row) => row.conceptId}
          columns={confusionMatrixColumns}
          useFetchDataGridData={useFetchDataGridData}
          sx={{ minHeight: 0 }}
          disableColumnSorting
          disableColumnFilter
          disableColumnMenu
          disableColumnResize
          hideFooterRowCount
        />
      </DataGridLayout>
    </ApiWorkflowDialog>
  );
};

export default AccuracyMatrix;
